import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { colors } from '../../styles/theme'
import media from '../../styles/media'

const S = {}

S.Loader = styled.div`
  .icon {
    color: ${colors.orange};
    display: block;
    margin: 0 auto;

    ${({ size }) =>
      size === 's' &&
      css`
        width: 1.5rem;
        height: 1.5rem;
      `};

    ${({ size }) =>
      size === 'm' &&
      css`
        width: 3rem;
        height: 3rem;
      `};

    ${({ size }) =>
      size === 'l' &&
      css`
        width: 3.75rem;
        height: 3.75rem;
      `};

    ${({ hasPadding }) =>
      hasPadding &&
      css`
        padding: 1.25rem;
      `};

    ${({ isPage }) =>
      isPage &&
      css`
        width: 2.5rem;
        height: 2.5rem;

        ${media.sm`
          width: 3.75rem;
          height: 3.75rem;
        `};
      `};
  }
`

export default S
